// src/app/auth/auth.routes.ts
import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './auth-layout.component';

export const authRoutes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent, // Optional: if you have an auth layout
    children: [
      {
        path: 'login',
        loadComponent: () => import('./login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'sso',
        loadComponent: () =>
          import('../supplier/pages/sso/sso.component').then((m) => m.SsoComponent),
      },
    ],
  },
];
